export default __webpack_public_path__ + "static/media/img--design-11.ac01bd43.jpg";